const AdminServiceStatus ='Wait for Admin Service';

export default AdminServiceStatus